module.exports = __webpack_public_path__ + "static/payment-3eef830d8e935dac8d211935955bcbf6.svg";